/**
 * TOSC5 implementation
 * Another part (quicksearch) is located in app.js
 */
(function() {
    const pageHeader = document.querySelector('#page-header');
    // window.tosc5Loader is registered through ext:tosc5 static typoscript
    window.addEventListener('tosc5config', (event) => {
        let queryString = location.search;
        let place;
        if (queryString.length > 0) {
            queryString = decodeURIComponent(queryString.substring(1));
            const args = queryString.split('&');
            const params = {};
            args.forEach(arg => {
                const [name, value] = arg.split('=', 2);
                params[name] = value;
            });
            if (params.hasOwnProperty('place')) {
                place = params.place;
            }
        }
        if (place) {
            event.detail.config.urlOptionalParams = `lkRG=TO&lkID=${place}`;
        }
        event.detail.config.allowScrollOnApplicationStart = false;
        if ('dw' in window && typeof window.dw === 'function' && pageHeader) {
            window['dw']('onGetAppContainerOffset', event.detail.tag, () => pageHeader.scrollHeight);
        }

    });
    // @todo remove once tosc5 page backend-layout has been removed
    if ('tosc5Loader' in window) {
        window.tosc5Loader();
    }
})();
